import { DialogComponent } from '@theme/dialog';

/**
 * Shared engraving preview modal.
 * Charge-row buttons live outside this element so cart morphs can replace them
 * without destroying an open preview.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 * @property {HTMLImageElement} image - The preview image.
 *
 * @extends {DialogComponent}
 */
class EngravingPreviewDialog extends DialogComponent {
  requiredRefs = ['dialog', 'image'];

  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    super.connectedCallback();

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    document.addEventListener('click', this.#openFromTrigger, { signal });
    this.refs.dialog.addEventListener('close', this.#clearPreview, { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    super.disconnectedCallback();
  }

  /**
   * @param {MouseEvent} event
   */
  #openFromTrigger = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-engraving-preview-trigger]');

    if (!(trigger instanceof HTMLButtonElement)) return;

    const url = trigger.dataset.engravingPreviewUrl;

    if (!url) return;

    event.preventDefault();

    this.refs.image.src = url;
    this.showDialog();
  };

  #clearPreview = () => {
    this.refs.image.removeAttribute('src');
  };
}

if (!customElements.get('engraving-preview-dialog')) {
  customElements.define('engraving-preview-dialog', EngravingPreviewDialog);
}
